/**
 * Where the public legal pages live, and which of them the profile menu lists.
 *
 * Separate from `content/legal/` on purpose: that module is counsel's text, regenerated
 * whenever counsel sends a revision, and nothing that routes or navigates may depend on
 * a generated file staying byte-for-byte the same.
 */

import type { LegalSlug } from "~/content/legal";

/** Pattern registered in both route tables; `:slug` is validated by `isLegalSlug`. */
export const LEGAL_ROUTE_PATH = "/legal/:slug";

export function legalPath(slug: LegalSlug): string {
  return `/legal/${slug}`;
}

/**
 * The i18n key naming each document in the app's own voice.
 *
 * Counsel's titles ("Elyxeer 30.5 Terms of Use") are right at the top of the document
 * and wrong in a menu row, where the product name is already established and the row
 * has to stay on one line on a phone.
 */
export const LEGAL_LABEL_KEYS: Record<LegalSlug, string> = {
  terms: "legal.menu.terms",
  privacy: "legal.menu.privacy",
  "account-deletion": "legal.menu.accountDeletion",
};
